module.exports = __webpack_public_path__ + "media/images/ir/common/icon_pdf-19ced8c3306c23210dde071e1c3db5de.svg";